'use strict';

angular.module('utils').factory('OCWizardUtil', function(WizardHandler) {
  return {
    setStep: function($scope, step) {
      $scope.$watch(function() {
        return WizardHandler.wizard();
      }, function(wizard) {
        if (wizard && !$scope.setInitialStep) {
          $scope.setInitialStep = true;
          for (var i = 0; i < step - 1; i++) {
            wizard.next();
          }
        }
      });
    },
  };
});
